import { Star, Quote } from "lucide-react";
import { Reveal } from "./motion";
import { REVIEWS } from "@/data/siteData";

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-brand font-semibold text-sm tracking-wide uppercase">Google Reviews</p>
            <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.1]">
              Trusted by California drivers
            </h2>
            <div className="mt-5 inline-flex items-center gap-3">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-accent text-accent" />)}
              </div>
              <span className="text-ink font-display font-bold text-lg">5.0</span>
              <span className="text-slate2 text-sm">· 10 Google reviews</span>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <figure data-testid={`review-${i}`} className="card-soft h-full p-7 lg:p-8 flex flex-col">
                <Quote size={26} className="text-accent/40" />
                <blockquote className="text-ink text-base leading-relaxed mt-3 flex-1">"{r.text}"</blockquote>
                <figcaption className="mt-6 pt-5 border-t border-gray-100 flex items-center justify-between">
                  <div>
                    <div className="font-display font-semibold text-ink text-sm">{r.name}</div>
                    <div className="text-slate2 text-xs">{r.city}, CA</div>
                  </div>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, s) => <Star key={s} size={14} className="fill-accent text-accent" />)}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
